import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalEditor = _resolveComponent("ModalEditor")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_SingleErrorMessage = _resolveComponent("SingleErrorMessage")!
  const _component_SuccessAlert = _resolveComponent("SuccessAlert")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalEditor, {
      activeTemplate: _ctx.letterTemplate || ({} as ITemplate),
      visible: _ctx.isShowingEditingModal,
      editorOnly: false,
      confirmButtonText: 'Generate',
      onOnTemplateSave: _ctx.onModalSave,
      onCloseModalEditor: _ctx.hideEditingModal
    }, null, 8, ["activeTemplate", "visible", "onOnTemplateSave", "onCloseModalEditor"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_container, {
          key: 0,
          fluid: "",
          style: {"display":"inline-grid","justify-content":"center"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LoadingSpinner, {
              fluid: "",
              style: {"display":"inline-grid","justify-content":"center"}
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_ctx.errorMessage != '')
                  ? (_openBlock(), _createBlock(_component_SingleErrorMessage, {
                      key: 0,
                      errorMessage: _ctx.errorMessage
                    }, null, 8, ["errorMessage"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_SuccessAlert, {
                  feedbackMessages: _ctx.successMessages,
                  timeout: 15000
                }, null, 8, ["feedbackMessages"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_ctx.availableHeaderTemplates.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      md: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, _mergeProps({
                          modelValue: _ctx.selectedHeaderTemplate,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedHeaderTemplate) = $event)),
                          items: _ctx.availableHeaderTemplates,
                          "item-title": "label"
                        }, {'return-object':true}, { "onUpdate:modelValue": _ctx.changeTemplateSelection }), null, 16, ["modelValue", "items", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.availableBodyTemplates.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      md: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, _mergeProps({
                          modelValue: _ctx.selectedBodyTemplate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBodyTemplate) = $event)),
                          items: _ctx.availableBodyTemplates,
                          "item-title": "label"
                        }, {'return-object':true}, { "onUpdate:modelValue": _ctx.changeTemplateSelection }), null, 16, ["modelValue", "items", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, { md: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.downloadedFilename,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.downloadedFilename) = $event)),
                      label: "Downloaded Filename (Optional)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                          _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            disabled: _ctx.availableHeaderTemplates.length === 0 && _ctx.availableBodyTemplates.length === 0,
                            class: "mx-2 mb-4",
                            color: "blue-grey-darken-1",
                            onClick: _ctx.doPreview
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode("Preview", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled", "onClick"])), [
                            [_directive_ripple]
                          ])
                        ], 16)
                      ]),
                      default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Review a filled in version of the template with the current context.", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.showGenerateButton)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      md: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                              _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                class: "mx-2 mb-4",
                                color: "blue-grey-darken-4",
                                disabled: !_ctx.canGenerate || _ctx.isGenerating,
                                onClick: _ctx.doGenerate
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.downloadButtonText), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])), [
                                [_directive_ripple]
                              ])
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.downloadTooltip), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.isGenerating)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_col, { md: "3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LoadingSpinner)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
  ], 64))
}